import React from 'react';

import { Container } from './styles';

const Inicio: React.FC = () => {
  return (
    <Container>
      <iframe
        title="Projetos - In Natura - SysIn"
        src="https://app.powerbi.com/view?r=eyJrIjoiNTNhZTk1ZjktZWM2NC00ZWUyLWI3N2QtYWExYzdiYWYxNmY5IiwidCI6ImMyM2E3OWQ1LTgwNTctNGZhZS04ODk1LWQyZjhkZDBjN2ExOCJ9"
        frameBorder="0"
        allowFullScreen
      />
    </Container>
  );
};

export default Inicio;
